export const VocabCivilStatus = {
    'single' : ['Solter@', 'Single'],
    'married' : ['Casad@', 'Married'],
  }
    